import { render } from "./ProviderDetail.vue?vue&type=template&id=7f80cd7e&scoped=true"
import script from "./ProviderDetail.vue?vue&type=script&lang=js"
export * from "./ProviderDetail.vue?vue&type=script&lang=js"

import "@/assets/css/layout_provider.css?vue&type=style&index=0&id=7f80cd7e&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f80cd7e"]])

export default __exports__